import swal from '../swal/swal.js';
import _ from 'lodash';

function error(title, data) {
    const html = `<pre style="text-align: left">${data}</pre>`;
    swal({
        title: title,
        text: html,
        html: true,
        type: 'error'
    });
}

function info(message, data, title) {
    toastr.info(message, title);
    // $log.info('Info: ' + title, data);
}

function success(message, data, title) {
    toastr.success(message, title);
    // $log.info('Success: ' + title, data);
}

function warning(message, data, title) {
    toastr.warning(message, title);
    // $log.warn('Warning: ' + title, data);
}

const logger = {

    error   : error,
    info    : info,
    success : success,
    warning : warning,
};

export {logger};



// WEBPACK FOOTER //
// ./app/components/common/logger/logger.js